<div class="auth__errors-container" *ngIf="error" @fadeInOut>
  <button id="close-error" class="auth__close-errors" type="button" (click)="close()">
    <sc-icon icon="close-elipse-flat"></sc-icon>
  </button>
  <div class="auth__error-messages">
    <div class="auth__error-message" *ngFor="let message of messages">
      {{ message }}
      <a *ngIf="error?.error?.navigate as navigate" [routerLink]="navigate.link">{{ navigate.text }}</a>
    </div>
  </div>
</div>
